import React from 'react';
import { css } from '@emotion/react';
import EditIcon from '@material-ui/icons/Edit';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { DeleteForeverOutlined } from '@material-ui/icons';
import { colors } from '@/styles';
import { commodityLabel } from './utils';
import CategorySelect from './CategorySelect';
import CommodityToggles from './CommodityToggles';
import TariffAssignments from './TariffAssignments';
import {
    ActionButton,
    CommodityPill,
    ExpandedPanel,
    PanelLabel,
    PanelLine,
    RowActions,
    RowCard,
    RowHeader,
    RowMeta,
    RowName,
    RowToggle,
} from './blocks';

const toggleOnKey = (onToggle) => (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onToggle();
    }
};

const TariffRow = ({
    tariff,
    name,
    expanded,
    disabled,
    showAssignments,
    meta,
    actions,
    onToggle,
    onEdit,
    onDuplicate,
    onDelete,
    onCategoryChange,
    onCommodityToggle,
}) => (
    <RowCard>
        <RowHeader>
            <RowToggle
                role="button"
                tabIndex={0}
                aria-expanded={expanded}
                onClick={onToggle}
                onKeyDown={toggleOnKey(onToggle)}
            >
                <RowName>{name}</RowName>
                {meta ? <RowMeta>{meta}</RowMeta> : null}
                {(tariff.commodity_tags || []).map((tag) => (
                    <CommodityPill key={tag}>{commodityLabel(tag)}</CommodityPill>
                ))}
            </RowToggle>
            <RowActions>
                {actions}
                <ActionButton aria-label="Edit tariff" iconColor={colors.greens.primary} onClick={onEdit}>
                    <EditIcon />
                </ActionButton>
                <ActionButton
                    aria-label="Copy tariff"
                    iconColor={colors.greys.primary}
                    disabled={disabled}
                    onClick={onDuplicate}
                >
                    <FileCopyIcon
                        css={css`
                            font-size: 20px;
                        `}
                    />
                </ActionButton>
                <ActionButton
                    aria-label="Delete tariff"
                    iconColor={colors.reds.cancelled}
                    disabled={disabled}
                    onClick={onDelete}
                >
                    <DeleteForeverOutlined />
                </ActionButton>
            </RowActions>
        </RowHeader>
        {expanded ? (
            <ExpandedPanel>
                <PanelLine>
                    <PanelLabel>CATEGORY:</PanelLabel>
                    <CategorySelect value={tariff.category} onChange={onCategoryChange} />
                    <PanelLabel>COMMODITIES:</PanelLabel>
                    <CommodityToggles value={tariff.commodity_tags} onToggle={onCommodityToggle} />
                </PanelLine>
                {showAssignments ? <TariffAssignments tariffId={tariff.tariff_id} /> : null}
            </ExpandedPanel>
        ) : null}
    </RowCard>
);

export default TariffRow;
